import { selectCoreLoading } from '../../store/core/coreSlice';
import { useAppSelector } from '../../store/hooks';
import '../../theme/shared.scss';
import { Loading } from './Loading';

export const LoadingOverlay = () => {
  const loading = useAppSelector(selectCoreLoading);

  if (!loading) return null;

  return <Loading />;
};
